
import { Options } from "vue-class-component";
import { Game } from "../../model/Game.model";
import Base from "../base/Base.vue";
@Options({
  props: ["game"]
})
export default class GameCard extends Base {
  game!: Game;
}
